import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { appconfig } from 'services/web/react/config/appconfig';
import { LoginCallback } from 'services/web/react/src/Login/IdentityService/LoginCallback';
import { LogoutCallback } from 'services/web/react/src/Login/IdentityService/LogoutCallback';
import { AuthenticationRouteGuard } from '../core/AuthenticationRouteGuard';
import { LoginRoutes } from '../src/Login/LoginRoutes';
import { SessionExpirationSentinal } from '../src/Login/SessionExpirationSentinal';
import { NgApp } from './ngapps/NgApp';
import { NgContactLessRegistrationApp } from './ngapps/NgContactlessRegistrationApp';
import { NgCustomerProfileApp } from './ngapps/NgCustomerProfileApp';
import { NgErrorApp } from './ngapps/NgErrorApp';
import { NgEventApp } from './ngapps/NgEventApp';
import { NgVerificationRequestFormApp } from './ngapps/NgVerificationRequestFormApp';
import { NgWebTicketViewApp } from './ngapps/NgWebTicketViewApp';
import { Providers } from './providers';
import { tryRedirect } from './redirects';

const root = createRoot(document.getElementById('react-root')!);

function main() {
  if (tryRedirect()) {
    return;
  }

  root.render(
    <Providers>
      <SessionExpirationSentinal />
      <BrowserRouter>
        <Routes>
          {/* The reset password page is still a legacy angular page */}
          <Route path="/account/reset-password" element={<NgApp />} />

          {/* The reset password page is still a legacy angular page */}
          <Route path="/account/setup-password" element={<NgApp />} />

          {/* account related pages like login/logout */}
          <Route path="/account/*" element={<LoginRoutes />} />

          {/* Event management portal */}
          <Route element={<AuthenticationRouteGuard />}>
            <Route path="/" element={<NgApp />} />
          </Route>

          {/* EO sigh up page: /eo/#createAnOrgAccount */}
          <Route path="/eo" element={<NgApp />} />

          {/* Event landing page and ticketing flows */}
          <Route path="/event/*" element={<NgEventApp />} />

          {/* Customer/Attendee portal */}
          <Route path="/myprofile/*" element={<NgCustomerProfileApp />} />

          {/* Contact less registration page */}
          <Route path="/clr" element={<NgContactLessRegistrationApp />} />

          {/* Verification request page */}
          <Route path="/vrf/*" element={<NgVerificationRequestFormApp />} />

          {/* Web transaction view */}
          <Route path="/wt/*" element={<NgWebTicketViewApp />} />

          {/* Vendor ticket page */}
          <Route path="/vtp/*" element={<NgEventApp />} />

          {/* Vednor sign up page */}
          <Route path="/vs/*" element={<NgEventApp />} />

          {/* Prize draw */}
          <Route path="/competition/*" element={<NgEventApp />} />

          {/* Accept shared ticket URL */}
          <Route path="/at/*" element={<NgEventApp />} />

          {/* Accept error ticket URL */}
          <Route path="/Error/*" element={<NgErrorApp />} />

          {/* The login/logout routes are part of the OpenID Connect authentication process (identity service) */}
          <Route path={new URL(appconfig.idp.redirect_uri).pathname} element={<LoginCallback />} />
          <Route path={new URL(appconfig.idp.post_logout_redirect_uri).pathname} element={<LogoutCallback />} />
        </Routes>
      </BrowserRouter>
    </Providers>
  );
}

main();
